import React, { Fragment } from "react";
import NewsfeedComment from "./NewsfeedComment";
import "./FriendNewsfeed.css";
import TextTheme from "components/General/Text/TextTheme";
import * as CONSTANT from "constants/text";
import NewsfeedCommentField from "components/Tribe/Friends/UserDetail/FriendNewsfeed/NewsfeedCommentField";
import AxiosConfig from "axiosConfig";

class NewsfeedCommentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      commentList: this.props.commentList,
      post_id: this.props.postId,
    };
  }

  componentDidMount() {  }

  handlePostButtonClick(comment, username, profilePic) {
    if (comment.length === 0) return;
    // make Axios call
    let form_data = new FormData();
    form_data.append("body", comment);
    form_data.append("post", this.state.post_id);
    AxiosConfig.post("posts/comment/", form_data);
    //append the new comment to the end of the commentList
    let newCommentList = this.state.commentList;
    //format the newComment as a JSON object. Just now will be the date until a new Axios call is made
    let newComment = {
      body: comment,
      username: username,
      created: "Just now",
      profile_pic: profilePic,
    };
    //append new comment and write to state
    newCommentList.push(newComment);
    //setting the state will allow the new comment to render in the comment thread
    this.setState({ commentList: newCommentList });
  }

  render() {
    return (
      <Fragment>
        {this.state.commentList.length > 0 ? (
          <Fragment>
            <div className="comment-wrapper">
              <TextTheme
                message={CONSTANT.COMMENT_THREAD}
                className="text_bold text_med_grey text_medium"
              />
              {this.state.commentList.map((elem) => (
                <NewsfeedComment
                  key={elem.created}
                  comment={elem.body}
                  username={elem.username}
                  profilePic={elem.profile_pic}
                  datePosted={elem.created}
                />
              ))}
            </div>
            <div className="post_comment_box">
              <TextTheme
                message={CONSTANT.POST_COMMENT}
                className="text_bold text_med_grey text_medium"
              />
              <NewsfeedCommentField
                username={this.props.username}
                profilePic={this.props.profilePic}
                postButtonClick={this.handlePostButtonClick.bind(this)}
              />
            </div>
          </Fragment>
        ) : (
          <div className="post_comment_box">
            <TextTheme
              message={CONSTANT.POST_COMMENT}
              className="text_bold text_med_grey text_medium"
            />
            <NewsfeedCommentField
              username={this.props.username}
              profilePic={this.props.profilePic}
              postButtonClick={this.handlePostButtonClick.bind(this)}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default NewsfeedCommentList;
